var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{class:[
    'preview-mode-tooltip',
    _vm.name ? `preview-mode-tooltip--${_vm.name}` : null,
  ],attrs:{"theme":"kinside-info","disabled":!_vm.$store.getters.isPreviewMode,"triggers":['hover', 'click', 'touch']},scopedSlots:_vm._u([{key:"popper",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.tooltipText)+"\n  ")]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }